module.exports = __webpack_public_path__ + "static/media/gif_acompanhamento.81c5ea77.gif";